import { memo } from 'react';
import { useAppSelector } from '../../common/hooks';
import { Spinner } from '../atoms';

const GlobalSpinnerOverlay = () => {
    const globalLoader = useAppSelector((state) => state.global.globalLoader);
    const loaderMessage = useAppSelector((state) => state.global.loaderMessage);
    const appLoaderIsLoading = useAppSelector((state) => state.appLoader.isLoading);
    const adviceClientLoading = useAppSelector((state) => state.adviceClient.loading);
    const adviceGoalsLoading = useAppSelector((state) => state.adviceGoals.loading);

    return (
        <Spinner
            enabled={globalLoader || appLoaderIsLoading || adviceClientLoading || adviceGoalsLoading}
            message={loaderMessage}
        />
    );
};

export default memo(GlobalSpinnerOverlay);
